import { observable, extendObservable } from "mobx";
import _ from "lodash";
import CargoService from "../../../services/CargoService";
import LotacaoService from "../../../services/LotacaoService";

//RHFPP-1548 - Consulta Custo Mot
export default class CalculoCustoMotFiltroStore {
    @observable exportOpen;

    @observable cargos = [];
    @observable lotacoes = [];
    @observable dataInicialSelecionada;
    @observable cpfSelecionado;
    @observable solicitacaoExcecaoSelecionada;

    @observable cargosValidacao;
    @observable lotacoesValidacao;
    @observable dataInicialValidacao;
    @observable dataFinalValidacao;
    @observable valorPropostoValidacao;

    constructor() {
        this.cargoService = new CargoService();
        this.lotacaoService = new LotacaoService();

        this.filtro = {};
    }

    carregarListas = (params, fields) => {
        extendObservable(this.filtro, params);

        this.carregarCargos();
        this.carregarLotacoes();

    }

    carregarCargos = () => {
        this.cargosValidacao = this.filtro.cargos;

        this.cargoService.listFromBase().then(response => {
            let cargos = response.data
                .filter(cargo => cargo)
                .map(cargo => ({
                    value: cargo.id,
                    label: cargo.nome + " (" + cargo.id + ")"
                }));

            this.cargos = _.orderBy(cargos, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarLotacoes = () => {
        this.lotacoesValidacao = this.filtro.lotacoes;

        this.lotacaoService.listAtivas().then(response => {
            let lotacoes = response.data
                .filter(lotacao => lotacao)
                .map(lotacao => ({
                    value: lotacao.id,
                    label: lotacao.nome
                }));

            this.lotacoes = _.orderBy(lotacoes, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    setCargo = (value) => {

        if (value && value != null) {

            const cargo = this.cargos.find(cargo => (cargo.value == value));

            this.filtro.cargoId = cargo.value;
            this.filtro.nomeCargo = cargo.label;
        } else {
            this.filtro.cargoId = null;
            this.filtro.nomeCargo = null;

        }
        this.cargosValidacao = value;
    }

    setLotacao = (value) => {
        this.filtro.lotacaoId = value;
        this.lotacoesValidacao = value;
    }

    setValorProposto = (value) => {
        this.filtro.valorProposto = value;
        this.valorPropostoValidacao = value;
    }

    toggleExport = () => {
        this.exportOpen = !this.exportOpen;
    }

    getFiltro = () => {
        //const filtro = { ...}

        return _.pickBy(this.filtro, _.identity);
    }

    limparFiltro = (fields) => {
        this.filtro = {};

        this.setCargo(null);
        this.setLotacao(null);
        this.setValorProposto(null);

        this.erro = null;
    }
}
